module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/arrow-next-5f48d5a1dfd02fe25a1e77c37052d015.svg&quot;;"